import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=6977df65&scoped=true&"
import script from "./registerUser.vue?vue&type=script&lang=js&"
export * from "./registerUser.vue?vue&type=script&lang=js&"
import style0 from "./registerUser.vue?vue&type=style&index=0&id=6977df65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977df65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6977df65')) {
      api.createRecord('6977df65', component.options)
    } else {
      api.reload('6977df65', component.options)
    }
    module.hot.accept("./registerUser.vue?vue&type=template&id=6977df65&scoped=true&", function () {
      api.rerender('6977df65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/registerUser.vue"
export default component.exports